import React from 'react';
import { Brand, Maybe, Price, ProductMedia } from '../../../../../types';
import { CurrentCampaign } from '../../../types';
import { SortOption } from '../../sort-options/types';
import * as S from '../styles';
import { insertTableAds } from '../ads';
import { PriceListTableRow, PriceListTableHeader } from '../price-list-table';

const PriceListBody: React.FC<IPriceListBodyProps> = props => {
  const {
    sortedPrices,
    showMorePrices,
    numberOfVisiblePrices,
    adOffset,
    ...priceListTableRowProps
  } = props;

  return (
    <S.PriceRowTable>
      <PriceListTableHeader />
      <tbody>
        {sortedPrices &&
          sortedPrices.length > 0 &&
          insertTableAds(
            sortedPrices
              .slice(0, showMorePrices ? undefined : numberOfVisiblePrices)
              .map((item, index) => {
                const rowKey = `${item.id}-${index}`;
                return (
                  <PriceListTableRow
                    key={rowKey}
                    item={item}
                    index={index}
                    {...priceListTableRowProps}
                  />
                );
              }),
            adOffset ?? 0
          )}
      </tbody>
    </S.PriceRowTable>
  );
};

interface IPriceListBodyProps {
  sortedPrices: Price[];
  showMorePrices: boolean;
  numberOfVisiblePrices: number;
  productId: number;
  productName?: string;
  campaign?: Maybe<CurrentCampaign>;
  media: ProductMedia & { first?: string | null };
  brand?: Maybe<Brand>;
  dispatchProductPriceClick: (
    id: number,
    price: Price | number,
    featured: boolean,
    status: string,
    isAlternative: boolean
  ) => void;
  dispatchProductClickOutBounce: (id: number, priceId?: string | null) => void;
  currentSort: SortOption;
  adOffset?: number;
  splitList?: boolean;
}

export default PriceListBody;
